import { useState, useEffect } from "react";
import InlineErrors from "components/shared/InlineErrors";
import InlineDescription from "./InlineDescription";
import CharacterCounter from "./CharacterCounter";

const InputTextArea = (props) => {
	const mainClass = "help-text-area";
	const {
		id,
		label,
		name,
		type,
		required,
		requiredText = "",
		placeholder,
		pattern,
		description,
		value = "",
		handleChange,
		notEmptyMessage,
		patternNotMatchMessage,
		inlineErrors,
		showInlineErrors = true,
		validateInput,
		isMobileView,
		modifier,
		characterCounter,
		maxCharacterLength = 14000,
		characterCounterLabel,
	} = props;

	const [hasError, setHasError] = useState();

	useEffect(() => {
		!!inlineErrors?.[name] && setHasError(true);
	}, [inlineErrors, name]);

	if (!name) return null;

	return (
		<div
			className={`${mainClass}${modifier ? ` ${mainClass}--${modifier}` : ""}`}
		>
			{characterCounter && (
				<CharacterCounter
					text={value}
					maxCharacterLength={maxCharacterLength}
					characterCounterLabel={characterCounterLabel}
				/>
			)}
			{label && (
				<label
					className={`${mainClass}__label${
						hasError ? ` ${mainClass}__label--error` : ""
					}${value ? ` ${mainClass}__label--filled` : ""}`}
					htmlFor={!hasError ? id : undefined}
					aria-label={`${label}${
						required && requiredText ? ` ${requiredText}` : ""
					}`}
				>
					{label && `${label}${required ? "*" : ""}`}
				</label>
			)}
			{description?.modalContent && (
				<InlineDescription
					{...description}
					isMobileView={isMobileView}
					position="top"
				/>
			)}
			<textarea
				className={`${mainClass}__text${
					hasError ? ` ${mainClass}__text--error` : ""
				}`}
				id={id}
				rows={type?.rows}
				cols={type?.cols}
				name={name}
				placeholder={placeholder}
				required={required}
				aria-required={required}
				aria-describedby={hasError ? `${id}_error` : undefined}
				value={value}
				onChange={handleChange}
				maxLength={maxCharacterLength}
				onBlur={() =>
					validateInput &&
					validateInput(
						name,
						value,
						required,
						notEmptyMessage,
						pattern,
						patternNotMatchMessage,
						setHasError
					)
				}
			/>
			{inlineErrors && showInlineErrors && (
				<InlineErrors validate={id} errorMessages={inlineErrors} />
			)}
			{description?.text && (
				<InlineDescription
					{...description}
					isMobileView={isMobileView}
					position="bottom"
				/>
			)}
		</div>
	);
};

export default InputTextArea;
